@use "variables" as *;

.wrapper {
  margin-right: $spacing-2;
}

.summarySkeleton {
  display: inline-block;
  width: 12px;
  margin-bottom: -3px;
  border-radius: 2px;
}
